
import EoCard from './EoCard'
import EoImg from '../EoImg/EoImg'

export default {
  name: 'EoCardCta',
  components: {
    EoCard,
    EoImg,
  },
  inheritAttrs: false,
  props: {
    to: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    cta: {
      type: String,
      default: null,
    },
    ctaColor: {
      type: String,
      default: null,
    },
    ctaTextColor: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes () {
      return {
        'eo-card-cta': true,
      }
    },
  },
}
